import script from "./ClientsIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientsIndex.vue?vue&type=script&setup=true&lang=js"

import "./ClientsIndex.vue?vue&type=style&index=0&id=a530c750&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a530c750"]])

export default __exports__